export const routes = [
  {
    path: '/foreignmarkets/restrictmeasures',
    name: 'RestrictionMeasuresPage',
    component: () => import('../views/RestrictionMeasuresPage.vue'),
  },
  {
    path: '/foreignmarkets/restrictmeasures/edit/:id',
    name: 'RestrictionMeasureEditPage',
    component: () => import('../views/RestrictionMeasureEditPage.vue'),
  },
  {
    path: '/foreignmarkets/customsduties',
    name: 'MacmaporgCustomsDuties',
    component: () => import('../views/MacmaporgCustomsDuties.vue'),
  },
  {
    path: '/foreignmarkets/customsduties/:action/:id',
    name: 'MacmaporgCustomsDutyCard',
    component: () => import('../views/MacmaporgCustomsDutyCard.vue'),
  },
  {
    path: '/foreignmarkets/statements',
    name: 'Statements',
    component: () => import('../views/Statements.vue'),
  },
  {
    path: '/foreignmarkets/statements/:action/:id',
    name: 'StatementCard',
    component: () => import('../views/StatementCard.vue'),
  },
  {
    path: '/foreignmarkets/analytics',
    name: 'Analytics',
    component: () => import('../views/Analytics.vue'),
  },
  {
    path: '/foreignmarkets/questions',
    name: 'Questions',
    component: () => import('../views/Questions.vue'),
  },
  {
    path: '/foreignmarkets/questions/:action/:id',
    name: 'QuestionCard',
    component: () => import('../views/QuestionCard.vue'),
  },
];
